import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { defineAsyncComponent } from "vue";
import useSearch from "@/SearchApp/composables/use-search";
import { isClassicSite } from "@ocm/services/ocm-object";


export default /*@__PURE__*/_defineComponent({
  __name: 'TypeAhead',
  setup(__props) {

const { isSearchMostSuggested } = useSearch();
const FindingsShop = defineAsyncComponent(() => import("./FindingsShop.vue"));
const FindingsClassic = defineAsyncComponent(() => import("./FindingsClassic.vue"));
const FindingsMostSuggested = defineAsyncComponent(() => import("./FindingsMostSuggested.vue"));

return (_ctx: any,_cache: any) => {
  return (_unref(isSearchMostSuggested))
    ? (_openBlock(), _createBlock(_unref(FindingsMostSuggested), { key: 0 }))
    : (_unref(isClassicSite))
      ? (_openBlock(), _createBlock(_unref(FindingsClassic), { key: 1 }))
      : (_openBlock(), _createBlock(_unref(FindingsShop), { key: 2 }))
}
}

})